// extracted by mini-css-extract-plugin
module.exports = {"container":"productDesigner_container__uh7km"};